export enum DialogTypeEnum {
  NONE,
  FORM,
  INFO,
  CONFIRM,
  DELETE,
}
